import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import axios from '../../util/Axios';
import { useEffect, useState } from 'react';

export function CopyDataSet({ dataSetId, dataSetName, handleClose, open }) {
  const [newId, setNewId] = useState('');
  const [newName, setNewName] = useState('');

  useEffect(() => {
    setNewId(`${dataSetId}_copy`);
    setNewName(`${dataSetName}_copy`);
  }, [dataSetId, dataSetName]);

  function handleCopy() {
    axios(`dataSets/${dataSetId}/copy`, {
      method: 'POST',
      data: { id: newId, name: newName },
    }).then((resp) => handleClose());
  }

  const handleChangeName = (event) => {
    setNewName(event.target.value);
  };

  const handleChangeId = (event) => {
    setNewId(event.target.value);
  };

  return (
    <>
      <Dialog open={open}>
        <DialogTitle>Copy Data Set {dataSetName}?</DialogTitle>
        <DialogContent>
          <TextField sx={{ m: 1, width: 300 }} label="Id" value={newId} onChange={handleChangeId} />
          <TextField sx={{ m: 1, width: 300 }} label="Name" value={newName} onChange={handleChangeName} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button variant="contained" onClick={handleCopy}>
            Copy
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
